import { Component, OnInit } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import {HandleWebParameterContextBeforeDBRequest,HandleServerContextAfterDBRequest} from '../../../../bizlogic/servicesbll';
import { BaseCase } from '../../../basecase';
declare var app;

@Component({
  selector: 'app-mz-leave',
  templateUrl: './mz-leave.component.html',
  styleUrls: ['./mz-leave.component.scss']
})
export class MzLeaveComponent extends GridBaseCase {
  month:any = new Date();
  searchDate = null;
  dataArray: any = {};
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService:BaseCase
  ) { super(); }

  LoadData() {
    const that = this;
    that.loading = false;
    that.apiObj['status'] = false;
    that.apiObj['msg'] = '';
    const pageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      const id = that.activaRouter.snapshot.paramMap.get('id');
      // console.log(id);
    let body: WebParameterContext = new WebParameterContext();
    // if (that.element.selectItemList.gridViewConfigName) {
    //   body.ConfigName = that.element.selectItemList.gridViewConfigName;
    // } else if (that.ConfigName) {
    //   body.ConfigName = that.ConfigName;
    // }
    body.ConfigName = "LeaveXML";
    body.OpType = "GETEDITE";
    body.ConfigType = "form";
    body.Client.Name = pageName;
    body.Client.PageName = pageName;
    // if (that.platform.is("android")) {
    //   body.Client.ClientType = 0;
    // } else if (that.platform.is("ios")) {
    //   body.Client.ClientType = 1;
    // }
    // body = HandleWebParameterContextBeforeDBRequest(body);
    // if (!body.ResponseMessage.Success) {
    //   that.msg.Alert(body.ResponseMessage.ErrorMessage);
    //   return;
    // }
    body.RequestBody=JSON.stringify({"a_ID":id.split('&')[0]});
    that.http.post(app.DEFAULTURL, body).then(data => {
      // data = HandleServerContextAfterDBRequest(body, data);
      // setTimeout(function () {
      //   that.apiObj['status'] = data.ResponseMessage.Success;
      //   that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      // });
      // that.dataArray = data.Status;
      // console.log(data);
      // that.dataArrayList = [];
      if (data.ResponseMessage.Success) {
        let item =data.Status;
          let objfield:any= {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              if(element.bindingField=="fields" && item[element.field]){//如果有附件需要处理
                let arrayimgurl = item[element.field].split(',');
                let imgurl:any =null;
                arrayimgurl.forEach(img=>{
                    if(!imgurl){
                      if(img.indexOf('http')>=0){
                        imgurl = img;
                      }else{
                        imgurl = (app.FileUoloadUrl+img).replace(app.ImagePlaceholder,app.SmallImageType);
                      }
                    }else{
                      if(img.indexOf('http')>=0){
                        imgurl +=","+img;
                      }else{
                        imgurl +=","+(app.FileUoloadUrl+img).replace(app.ImagePlaceholder,app.SmallImageType);
                      }
                    }
                });
                // let imgurl = app.UPLOADREADURL+item[element.field]+"&size=1";
                // console.log(imgurl);
                objfield[element.bindingField] ={"text":element.text,"value": imgurl};
              }else{
                objfield[element.bindingField] ={"text":element.text,"value": item[element.field]};
              }
            }
          });
          if(item["CHILDOBJ_TypeOfLeaveSysUserXML"]){
            objfield["userData"]=new Array<any>();
            objfield.userData=item["CHILDOBJ_TypeOfLeaveSysUserXML"].Datas;
            objfield.userData.forEach(items=>{
                  if(items.b_pic){
                    items.b_pic=(app.FileUoloadUrl+items.b_pic).replace(app.ImagePlaceholder,app.SmallImageType);
                  }
            });
          }
          that.dataArray = objfield;
         
          // console.log(that.element.selectItemList.selectItem);
          // console.log(that.dataArray);
      } else {
        // console.log(data.ResponseMessage.ErrorMessage);
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
      // that.gridDataList=data.Status.Datas;

      // data.Status.Datas.forEach(function (item) {
      //   let newsItem = {
      //     id: item[that.newsItem['idKey']] || '',
      //     title: item[that.newsItem['titleKey']] || '',
      //     time: item[that.newsItem['timeKey']] || '',
      //     author: item[that.newsItem['authorKey']] || '',
      //     rightIcon: item[that.newsItem['rightIconKey']] || ''
      //   }
      //   that.gridDataList.push(newsItem);
      // })

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }
  /**
   * 判断状态
   */
  format(value){
     if(value ==0 || value == null|| value==undefined){
      return "待审核";
     }else if(value ==1){
      return "已通过";
    }else if(value ==2){
      return "已驳回";
    }else if(value ==3){
      return "已撤销";
    }
  }
/**
 * 撤销请假
 * @param row 当前请假详情数据
 */
  EventBtn(row){
    console.log(row);
    const that = this;
    const pageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const id = that.activaRouter.snapshot.paramMap.get('id');
  let body: WebParameterContext = new WebParameterContext();
      body.ConfigName = "LeaveXML";
      body.OpType = "EDITE";
      body.ConfigType = "form";
      body.Client.Name = pageName;
      body.Client.PageName = pageName;
      body.RequestBody=JSON.stringify({"a_ID":id.split('&')[0],"a_AuditStatus":3});//a_AuditStatus = 3 表示撤销
    that.http.post(app.DEFAULTURL, body).then(data => {
    if (data.ResponseMessage.Success) {
      that.com.removeBack();
        // that.router.navigate(["/tabs/contact/LeaveReport/view/"+that.com.getNowDatetime]);
        that.com.Go("/tabs/contact/LeaveReport/view/"+that.com.getNowDatetime);
    } else {
      // console.log(data.ResponseMessage.ErrorMessage);
      that.msg.Alert(data.ResponseMessage.ErrorMessage);
    }
  }).catch(error => {
    console.log(error);
      that.msg.Show("系统错误,请联系管理员")
  })
  }
  imgPreview(img:any="") {
    let that = this;
    let url = img;
    if(url){
      url = img.trim().replace(app.SmallImageType,app.BigImageType);
      let ImgPreview = {
        imgUrl:[url],
        index:1
      }
      // localStorage.setItem("ImgPreview",JSON.stringify(ImgPreview));
      // that.router.navigate(["/tabs/contact/ImgPreview"]);
      that.com.setHistoryUrl();
      that.com.Go("/tabs/contact/ImgPreview/"+that.com.getNowDatetime,{
        ImgPreview:JSON.stringify(ImgPreview)
      });
      // that.router.navigate(["/tabs/contact/ImgPreview/"+that.com.getNowDatetime],{
      //   queryParams:{
      //     ImgPreview:JSON.stringify(ImgPreview)
      //   }
      // });
    }
  }
}
